// extracted by mini-css-extract-plugin
export default {"root":"eHTfjf","title":"rROfIb","gallery":"RNiEXv","caption":"qxvDC2","accessibilityTheme":"pE4TUZ","accessibilityThemeLink":"meqCFA"};